// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.startButton_NtC5r {
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: var(--white-background);
  font-size: 18px;
  font-weight: 400;
  background: var(--_10a37f-background);
  width: 100%;
  max-width: 200px;
  height: 57px;
  min-height: 57px;
  text-decoration: none;
  gap: 15px;
  padding: 0px 18px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  text-wrap: nowrap;
  img {
    height: 15px;
  }
  &:hover{
    background: #08bb8e;

  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FreeTrialButton/FreeTrialButton.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB;IACE,YAAY;EACd;EACA;IACE,mBAAmB;;EAErB;AACF","sourcesContent":[".startButton {\n  margin-top: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  color: var(--white-background);\n  font-size: 18px;\n  font-weight: 400;\n  background: var(--_10a37f-background);\n  width: 100%;\n  max-width: 200px;\n  height: 57px;\n  min-height: 57px;\n  text-decoration: none;\n  gap: 15px;\n  padding: 0px 18px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  text-wrap: nowrap;\n  img {\n    height: 15px;\n  }\n  &:hover{\n    background: #08bb8e;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"startButton": `startButton_NtC5r`
};
export default ___CSS_LOADER_EXPORT___;
